<template>
    <section style="background-image: url('images/hero-3.jpg'); background-position: bottom;" class="pt-5">

       <Nav/>

        <div class="container rrc-intro-inner-page-container d-flex align-items-center">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="rrc-typo-shadow" v-html="$t('latest-news.title')"></h1>
                </div>
            </div>
        </div>

    </section>
</template>

<script setup>
import Nav from "@/components/Nav";
</script>